/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { GuardContext, GuardResourceContext } from './context';

import type { ACTIONS } from './types';

export const useGuard = () => {
    const { guard } = useContext(GuardContext);
    const { resourceName } = useContext(GuardResourceContext);

    return {
        canAction: (action: ACTIONS, specifiedResourceName?: string | null) => {
            const protectedResourceName = specifiedResourceName || resourceName;
            if (!protectedResourceName) {
                throw new Error(
                    'useGuard error: you must defined resourceName as argument or by context'
                );
            }

            return guard.can(protectedResourceName, action);
        },
    };
};
